(function () {
  const config = window.NaerSurveyResponse;
  if (!config) return;

  const root = document.querySelector("[data-survey-response-root]");
  if (!root) return;

  const errorEl = root.querySelector("[data-survey-error]");
  const contentEl = root.querySelector("[data-survey-content]");

  const params = new URLSearchParams(window.location.search);
  const email = (params.get("email") || "").trim();
  const scoreRaw = (params.get("score") || "").trim();
  const scoreNum = parseInt(scoreRaw, 10);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid =
    email.length > 0 &&
    emailPattern.test(email) &&
    scoreRaw.length > 0 &&
    Number.isFinite(scoreNum) &&
    scoreNum >= 1 &&
    scoreNum <= 5;

  const FORM_READY_TIMEOUT_MS = 10000;
  const FIELD_RETRY_INTERVAL_MS = 200;
  const FIELD_RETRY_MAX_MS = 10000;

  function showError() {
    if (errorEl) errorEl.hidden = false;
    if (contentEl) contentEl.hidden = true;
  }

  function showContent() {
    if (errorEl) errorEl.hidden = true;
    if (contentEl) contentEl.hidden = false;
  }

  if (!isValid) {
    showError();
    return;
  }

  showContent();

  function getFormWrapper(role, formId) {
    const byRole = root.querySelector(`[data-survey-form="${role}"]`);
    if (byRole) return byRole;

    const formRoot = root.querySelector(
      `[data-forms-id="forms-root-${formId}"]`
    );
    return formRoot?.closest(".m-survey-response__form") || null;
  }

  const hiddenWrapper = getFormWrapper("hidden", config.hiddenFormId);
  const visibleWrapper = getFormWrapper("visible", config.visibleFormId);

  function dispatchInputEvents(field) {
    field.dispatchEvent(
      new Event("input", { bubbles: true, cancelable: true })
    );
    field.dispatchEvent(
      new Event("change", { bubbles: true, cancelable: true })
    );
    field.dispatchEvent(new Event("blur", { bubbles: true, cancelable: true }));
  }

  function setNativeValue(field, value) {
    try {
      const prototype =
        field instanceof HTMLTextAreaElement
          ? HTMLTextAreaElement.prototype
          : field instanceof HTMLSelectElement
            ? HTMLSelectElement.prototype
            : HTMLInputElement.prototype;

      const descriptor = Object.getOwnPropertyDescriptor(prototype, "value");
      if (descriptor?.set) {
        descriptor.set.call(field, value);
      } else {
        field.value = value;
      }
    } catch {
      field.value = value;
    }

    dispatchInputEvents(field);
  }

  function normalizeLabel(text) {
    return (text || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function getSearchRoots(container) {
    const roots = [];
    const seen = new Set();

    function addRoot(node) {
      if (!node || seen.has(node)) return;
      seen.add(node);
      roots.push(node);
    }

    addRoot(container);

    for (const embed of container.querySelectorAll(
      "form-embed, shopify-forms-embed"
    )) {
      addRoot(embed.shadowRoot);
      addRoot(embed);
    }

    for (const formRoot of container.querySelectorAll('[data-form-root="true"]')) {
      addRoot(formRoot);
      for (const embed of formRoot.querySelectorAll(
        "form-embed, shopify-forms-embed"
      )) {
        addRoot(embed.shadowRoot);
        addRoot(embed);
      }
    }

    return roots;
  }

  function queryAllRoots(roots, selector) {
    const results = [];
    for (const searchRoot of roots) {
      results.push(...searchRoot.querySelectorAll(selector));
    }
    return results;
  }

  function isFormControl(element) {
    if (!element) return false;
    const tag = element.tagName;
    return tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA";
  }

  function findControlInContainer(container) {
    if (!container) return null;
    return container.querySelector("input, select, textarea");
  }

  function resolveControlFromLabel(label, roots) {
    const container = label.closest(
      '[class*="formFieldContainer"], [class*="Field"], [class*="field"]'
    );

    const containerControl = findControlInContainer(container);
    if (containerControl) return containerControl;

    const fieldId = label.getAttribute("for");
    if (fieldId) {
      for (const searchRoot of roots) {
        const byId =
          (typeof searchRoot.getElementById === "function" &&
            searchRoot.getElementById(fieldId)) ||
          searchRoot.querySelector(`#${CSS.escape(fieldId)}`) ||
          searchRoot.querySelector(
            `[id="${fieldId.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"]`
          );

        if (isFormControl(byId)) return byId;

        if (fieldId.startsWith("label-")) {
          const inputId = fieldId.slice("label-".length);
          const byInputId =
            (typeof searchRoot.getElementById === "function" &&
              searchRoot.getElementById(inputId)) ||
            searchRoot.querySelector(
              `[id="${inputId.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"]`
            );
          if (isFormControl(byInputId)) return byInputId;
        }
      }
    }

    const labelledBy = label.id;
    if (labelledBy) {
      for (const searchRoot of roots) {
        const byLabelledBy = searchRoot.querySelector(
          `[aria-labelledby="${CSS.escape(labelledBy)}"]`
        );
        if (isFormControl(byLabelledBy)) return byLabelledBy;
      }
    }

    return findControlInContainer(label.parentElement);
  }

  function findFieldByLabel(roots, labelText) {
    const target = normalizeLabel(labelText);

    for (const label of queryAllRoots(roots, "label")) {
      if (!normalizeLabel(label.textContent).includes(target)) continue;
      return resolveControlFromLabel(label, roots);
    }

    return null;
  }

  function resolveField(roots, fieldConfig) {
    if (fieldConfig.selector) {
      for (const searchRoot of roots) {
        const bySelector = searchRoot.querySelector(fieldConfig.selector);
        if (isFormControl(bySelector)) return bySelector;
      }
    }

    if (fieldConfig.label) {
      const byLabel = findFieldByLabel(roots, fieldConfig.label);
      if (isFormControl(byLabel)) return byLabel;
    }

    return null;
  }

  function findFieldWrapper(field) {
    if (!field) return null;

    return (
      field.closest('[class*="formFieldContainer"]') ||
      field.closest('[class*="formFieldset"]') ||
      field.closest('[class*="field"]') ||
      field.closest('[class*="Field"]') ||
      null
    );
  }

  function hideField(field) {
    if (!field) return;

    const wrapper = findFieldWrapper(field);
    if (wrapper) {
      wrapper.style.display = "none";
      wrapper.setAttribute("aria-hidden", "true");
      return;
    }

    field.style.display = "none";
  }

  function findScoreField(roots, score) {
    for (const searchRoot of roots) {
      const bySelector = searchRoot.querySelector(
        '[id*="satisfaction_score"], [data-testid*="satisfaction_score"]'
      );
      if (isFormControl(bySelector)) return bySelector;
    }

    const field = resolveField(roots, config.fields.score);
    if (isFormControl(field)) return field;

    const scoreString = String(score);

    for (const radio of queryAllRoots(
      roots,
      `input[type="radio"][value="${CSS.escape(scoreString)}"]`
    )) {
      return radio;
    }

    for (const label of queryAllRoots(roots, "label")) {
      if (!normalizeLabel(label.textContent).includes("tilfredshed (1-5)")) {
        continue;
      }

      const container =
        label.closest('[class*="field"]') ||
        label.closest('[class*="Field"]') ||
        label.parentElement;

      if (!container) continue;

      const containerRadio = container.querySelector(
        `input[type="radio"][value="${CSS.escape(scoreString)}"]`
      );
      if (containerRadio) return containerRadio;

      const containerButton = container.querySelector(
        `[data-value="${CSS.escape(scoreString)}"], button[value="${CSS.escape(scoreString)}"]`
      );
      if (containerButton) return containerButton;
    }

    return null;
  }

  function setScoreValue(roots, field, score) {
    const scoreString = String(score);

    if (field.tagName === "SELECT") {
      setNativeValue(field, scoreString);
      return;
    }

    if (field.type === "radio") {
      const groupName = field.name;
      const radios = groupName
        ? queryAllRoots(
            roots,
            `input[type="radio"][name="${CSS.escape(groupName)}"]`
          )
        : queryAllRoots(roots, 'input[type="radio"]');

      for (const radio of radios) {
        if (radio.value === scoreString) {
          radio.checked = true;
          dispatchInputEvents(radio);
          return;
        }
      }
    }

    if (field.tagName === "BUTTON" || field.getAttribute("role") === "radio") {
      field.click();
      return;
    }

    if (
      field.type === "number" ||
      field.type === "text" ||
      field.tagName === "TEXTAREA"
    ) {
      setNativeValue(field, scoreString);
      return;
    }

    setNativeValue(field, scoreString);
  }

  function getFormState(container) {
    const roots = getSearchRoots(container);
    const forms = queryAllRoots(roots, "form");
    const submitButtons = queryAllRoots(
      roots,
      'button[type="submit"], input[type="submit"]'
    );

    return {
      roots,
      form: forms[0] || null,
      submitButton: submitButtons[0] || null,
      hasFields: queryAllRoots(roots, "input, select, textarea").length > 0,
    };
  }

  function waitForFormReady(container, options) {
    const requireSubmit = options?.requireSubmit !== false;

    return new Promise((resolve, reject) => {
      const deadline = Date.now() + FORM_READY_TIMEOUT_MS;
      let observer;
      let interval;

      const cleanup = () => {
        if (observer) observer.disconnect();
        if (interval) window.clearInterval(interval);
      };

      const tryResolve = () => {
        const state = getFormState(container);

        if (state.hasFields) {
          if (!requireSubmit || (state.form && state.submitButton)) {
            cleanup();
            resolve(state);
            return true;
          }
        }

        if (Date.now() >= deadline) {
          cleanup();
          reject(new Error("Survey form did not initialize in time"));
          return true;
        }

        return false;
      };

      if (tryResolve()) return;

      observer = new MutationObserver(() => {
        tryResolve();
      });

      observer.observe(container, {
        attributes: false,
        childList: true,
        subtree: true,
      });

      interval = window.setInterval(() => {
        tryResolve();
      }, FIELD_RETRY_INTERVAL_MS);
    });
  }

  function waitForFields(getFields, timeoutMs) {
    return new Promise((resolve) => {
      const deadline = Date.now() + timeoutMs;

      const attempt = () => {
        const result = getFields();
        if (result) {
          resolve(result);
          return;
        }

        if (Date.now() >= deadline) {
          resolve(null);
          return;
        }

        window.setTimeout(attempt, FIELD_RETRY_INTERVAL_MS);
      };

      attempt();
    });
  }

  function getHiddenFormFields(roots) {
    return {
      emailField: resolveField(roots, config.fields.email),
      scoreField: findScoreField(roots, scoreNum),
    };
  }

  function applyHiddenFormFill(roots) {
    const { emailField, scoreField } = getHiddenFormFields(roots);
    if (!isFormControl(emailField) || !isFormControl(scoreField)) return false;

    setNativeValue(emailField, email);
    setScoreValue(roots, scoreField, scoreNum);
    return true;
  }

  function isHiddenFormFilled(roots) {
    const { emailField, scoreField } = getHiddenFormFields(roots);
    return (
      isFormControl(emailField) &&
      isFormControl(scoreField) &&
      emailField.value === email &&
      scoreField.value === String(scoreNum)
    );
  }

  function submitHiddenForm(state) {
    window.setTimeout(() => {
      if (state.submitButton) {
        state.submitButton.click();
        return;
      }

      if (state.form) {
        state.form.requestSubmit();
      }
    }, 150);
  }

  function applyVisibleFormFill(roots) {
    const emailField = resolveField(roots, config.visibleFields.email);
    if (!isFormControl(emailField)) return false;

    setNativeValue(emailField, email);
    hideField(emailField);
    return true;
  }

  async function initHiddenForm() {
    if (!hiddenWrapper) {
      console.warn("[survey-response] Hidden form wrapper not found");
      return;
    }

    try {
      const state = await waitForFormReady(hiddenWrapper, {
        requireSubmit: true,
      });

      const filled = await waitForFields(() => {
        if (!applyHiddenFormFill(state.roots)) return null;
        if (!isHiddenFormFilled(state.roots)) return null;
        return state;
      }, FIELD_RETRY_MAX_MS);

      if (!filled) {
        const fields = getHiddenFormFields(state.roots);
        console.warn("[survey-response] Hidden form fields not found", {
          email: Boolean(fields.emailField),
          score: Boolean(fields.scoreField),
          emailValue: fields.emailField?.value,
          scoreValue: fields.scoreField?.value,
        });
        return;
      }

      submitHiddenForm(filled);
    } catch (error) {
      console.warn("[survey-response] Hidden form auto-submit failed", error);
    }
  }

  async function initVisibleForm() {
    if (!visibleWrapper) {
      console.warn("[survey-response] Visible form wrapper not found");
      return;
    }

    try {
      const state = await waitForFormReady(visibleWrapper, {
        requireSubmit: false,
      });

      const filled = await waitForFields(() => {
        if (applyVisibleFormFill(state.roots)) return true;
        return null;
      }, FIELD_RETRY_MAX_MS);

      if (!filled) {
        console.warn("[survey-response] Visible form email field not found");
      }
    } catch (error) {
      console.warn("[survey-response] Visible form prefill failed", error);
    }
  }

  initHiddenForm();
  initVisibleForm();
})();
